import { type PartialDeep } from 'type-fest';

import { type CanvasElementFrom } from '@blaze-runtime/engine-domain';
import { type BlazeSchema } from '@blaze-shared/schema-domain';

import { type DefinitionMapper } from '../../../ai';
import { type CanvasElementDefinition } from '../../../canvas-elements/element-definition';

import { type DatetimeInputDefinition } from './datetime-input.definition';

export class DatetimeInputDefinitionMapper implements DefinitionMapper<'datetimeInput'> {
  readonly type = 'datetimeInput';

  extract(
    element: CanvasElementFrom<'datetimeInput'>,
    _schemas: Readonly<Record<string, BlazeSchema>>,
    _definition: CanvasElementDefinition<'datetimeInput'>,
  ): PartialDeep<DatetimeInputDefinition> {
    const { title, date, time } = element.props.content;

    return {
      label: title?.label,
      showLabel: title?.enabled,
      iconName: title?.icon,
      tooltip: title?.tooltip,
      isReadOnly: date?.readonly,
      isDateEnabled: date?.enabled,
      isTimeEnabled: time?.enabled,
      styleName: element.props.styleConfig?.styleName,
    };
  }
}
